/**
 * 卡密即将过期提醒条
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import styles from './CardExpireAlert.module.css';

export function CardExpireAlert({ expire_at }) {
  const navigate = useNavigate();
  const days = dayjs(expire_at).diff(dayjs(), 'day');

  return (
    <div className={styles.alert}>
      <span>⚠️ 您的卡密将在 <strong>{days}</strong> 天后到期（{dayjs(expire_at).format('YYYY-MM-DD')}），请及时续费</span>
      <button className={styles.btn} onClick={() => navigate('/card')}>
        立即续费
      </button>
    </div>
  );
}
